import React from 'react';
import './Skelton.scss';

export const Skelton  = (props:any) => {
    let styles = {
        width: props.width,
        height:props.height,
        borderRadius: '6px'
    }
    if(props.circle) styles['borderRadius'] = '50%';
    return(
        <div className={`sk-loading ${props.class}`} 
                style={styles}>
        </div>
    )
}